import { useEffect, useMemo, useState } from 'react';

export function useDarkMode() {
  const [dark, setDark] = useState(() =>
    document.documentElement.classList.contains('dark')
  );
  useEffect(() => {
    const obs = new MutationObserver(() =>
      setDark(document.documentElement.classList.contains('dark'))
    );
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
    return () => obs.disconnect();
  }, []);
  return dark;
}

export function useIsMobile(breakpoint = 640) {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint
  );
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [breakpoint]);
  return isMobile;
}

export function useChartColors(dark: boolean) {
  return useMemo(
    () => ({
      bar: dark ? '#3b82f6' : '#103254',
      income: '#22c55e',
      expenses: '#ef4444',
      profit: dark ? '#60a5fa' : '#2170b8',
      previous: dark ? '#6b7280' : '#9ca3af',
      grid: dark ? 'rgba(255,255,255,0.06)' : 'rgba(16,50,84,0.08)',
      tooltipBg: dark ? 'rgba(31,41,55,0.95)' : 'rgba(255,255,255,0.95)',
      tooltipBorder: dark ? '#374151' : '#e5e7eb',
      tooltipText: dark ? '#f9fafb' : '#103254',
      tickFill: dark ? '#9ca3af' : '#6b7280',
      arcText: dark ? '#e5e7eb' : '#103254',
      cursor: dark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
    }),
    [dark]
  );
}
